<table class="table table-striped" data-test="lbgReportBuildingsTable">
  <thead>
    <th style="width: 35%">{{ 'lbgPortfolioRoadmapReport.buildings.address' | translate }}</th>
    <th class="text-end">{{ 'lbgPortfolioRoadmapReport.buildings.epcImprovement' | translate }}</th>
    <th class="text-end">{{ 'lbgPortfolioRoadmapReport.buildings.epcValidUntil' | translate }}</th>
    <th class="text-end">{{ 'lbgPortfolioRoadmapReport.buildings.emissionsReduction' | translate }}</th>
    <th class="text-end">{{ 'lbgPortfolioRoadmapReport.buildings.paybackPeriod' | translate }}</th>
  </thead>
  <tbody>
    @for (data of buildings(); track data.id) {
      <tr>
        <td>
          <div class="d-flex align-items-center">
            <cfp-street-view-image
              class="d-flex align-items-center"
              [buildingId]="data.id"
              [address]="data.displayAddress"
              [size]="'sm'"
              [showMonumentIcon]="data.monument"
            />
            <div class="ms-3 mb-0" [buildingAddress]="data.displayAddress" [countryCode]="data.countryCode"></div>
            <div class="d-flex ms-auto">
              @if (data.greenLoanEligible) {
                <cfp-icon [icon]="'leaf'" [iconStyle]="'success'" />
              }
              <cfp-badge [badgeStyle]="'secondary'" [classes]="'ms-2'" [class.opacity-0]="!data.roadmap">
                {{ 'portfolioBuildingsRoadmapReport.plan' | translate }}
              </cfp-badge>
            </div>
          </div>
        </td>
        <td class="text-end">
          <div class="d-flex align-items-center justify-content-end">
            <div class="d-inline-flex">
              @if (data.energyLabels.currentEnergyLabel) {
                <cfp-energy-label
                  [energyLabel]="data.energyLabels.currentEnergyLabel"
                  [clarificationEnergyLabel]="data.energyLabels.clarificationLabel"
                  [showClarificationInline]="true"
                  [labelSituationType]="data.energyLabels.labelSituationType"
                  [size]="'sm'"
                />
                <cfp-icon
                  [icon]="'arrow-right'"
                  [iconSize]="'large'"
                  [classes]="'mx-3'"
                  [class.opacity-0]="!data.energyLabels.improvedEnergyLabel || !data.roadmap"
                />
                <cfp-energy-label
                  [energyLabel]="data.energyLabels.improvedEnergyLabel"
                  [size]="'sm'"
                  class="energy-label-fixed-width"
                  [class.opacity-0]="!data.energyLabels.improvedEnergyLabel || !data.roadmap"
                />
              }
            </div>
          </div>
        </td>
        <td class="text-end">
          @let isRegistered =
            data.energyLabels.currentEnergyLabel.labelType === EnergyLabelTypeDTO.REGISTERED ||
            data.energyLabels.clarificationLabel?.labelType === EnergyLabelTypeDTO.REGISTERED;
          @let validUntil =
            data.energyLabels.currentEnergyLabel.validUntil ?? data.energyLabels.clarificationLabel?.validUntil;
          @if (validUntil && isRegistered) {
            {{ validUntil | date: 'longDate' }}
          }
        </td>
        <td class="text-end">
          @if (data.roadmap) {
            {{ data.emissionsReductionPercentage | number: '1.0-0' }}%
          }
        </td>
        <td class="text-end">
          @if (data.roadmap) {
            {{ data.paybackPeriodYears | number: '1.0-1' }}
            {{ 'paybackPeriod.years' | translate }}
          }
        </td>
      </tr>
    }
  </tbody>
</table>
